// @flow
import { createSelector } from 'reselect';
import _ from 'lodash';
import type { TRootStore } from "../../types";

export const getUser = (state: TRootStore) => state.user.data;
export const hasUser = (state: TRootStore) => Boolean(state.user.data.id);
export const isUserPending = ({ user }: TRootStore) => user.user.is_pending;
export const getUserAvatar = ({ user }: TRootStore) => {
	const { avatar_version, id } = user.data,
		avatar_path = process.env.REACT_APP_AVATARS_PATH || '';

	return id ? `${avatar_path}${id}.png?v=${avatar_version}` : false;
};
export const getTrialEnd = ({ user }: TRootStore) => user.data.trial_end;
export const getCoachPlan = ({ user }: TRootStore) => user.data.assistant_coach_plan;

export const getWithTrial = createSelector(
	getCoachPlan,
	getTrialEnd,
	( assistant_coach_plan, trial_end ) => {
		const is_trial_plan = assistant_coach_plan === 'trial';

		return is_trial_plan && Boolean(trial_end);
	}
);
export const getTrialDaysToEnd = createSelector(
	getWithTrial,
	getTrialEnd,
	(with_trial, trial_end) => {
		if (!with_trial || !trial_end) {
			return 0;
		}

		const
			minute = 1000 * 60,
			hour = minute * 60,
			day = hour * 24,

			now = Date.now(),
			trial_end_date = new Date(trial_end);

		return Math.ceil((trial_end_date - now) / day);
	}
);

export const isCoachTrialEnd = createSelector(
	getTrialDaysToEnd,
	trial_days_to_end => {
		if (_.isUndefined(trial_days_to_end)) {
			return false;
		}

		return trial_days_to_end <= 0;
	}
);


// WEBPACK FOOTER //
// ./src/modules/selectors/user/index.js